import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EAnswerTextTypes {
  Set = 'NEW_ANSWER/TEXT/SET',
}

export type TSetAnswerText = ITypedReduxAction<EAnswerTextTypes.Set, string>;

/**
 * Redux action, который записывает в store ЖК нового ответ
 * @param text string
 */
export const setAnswerText: (text: string) => TSetAnswerText = actionGenerator<EAnswerTextTypes.Set, string>(
  EAnswerTextTypes.Set,
);
